import { useCallback } from 'react';
import { getFlowKey } from '../routing/getFlowKey';
import { getHubSpotConversationsClient } from './getHubSpotConversationsClient';
import { shouldShowChatBot } from './shouldShowChatBot';
export const useSetupChatbot = ({
  loaded,
  setLoaded,
  isSU0004Variation = false
}) => {
  const setupChatbot = useCallback(() => {
    const flowKey = getFlowKey();
    const conversationsClient = getHubSpotConversationsClient();
    const showChatBot = shouldShowChatBot({
      flowKey,
      isSU0004Variation
    });
    if (showChatBot && conversationsClient && conversationsClient.widget && !loaded) {
      //This is so that we can use the Manage Cookies modal while the chatbot is on the page
      const interval = setInterval(() => {
        const container = document.getElementById('hubspot-messages-iframe-container');
        if (container) {
          container.style.zIndex = '1';
          clearInterval(interval);
        }
      }, 500);
      conversationsClient.widget.load();
      setLoaded(true); // it is actually not loaded but more like it's loading.
    }
  }, [loaded, setLoaded, isSU0004Variation]);
  return {
    setupChatbot
  };
};